export default __webpack_public_path__ + "static/slg-0501ec06d8afb9fa494953d2c6af49c8.png";